module.exports = {
  blue: '#4050f0',
  white: '#fff',
  red: '#e00',
}